export default __webpack_public_path__ + "media/landscape/logo_sonos-6b535745.svg";